import { getTransformedAccountSubscriptions } from './utils';
import { selectSubscriptionUsage } from './selectors';
import { useSelectUserContext } from '@innovyze/stylovyze/lib/selectors';
import { useSelector } from 'react-redux';
export function useAccountSubscriptions(subscriptionsSet) {
    const { list: accountSubscriptions, initialized } = useSelector(selectSubscriptionUsage);
    return {
        ...getTransformedAccountSubscriptions(accountSubscriptions, subscriptionsSet),
        initialized,
    };
}
export function useUserSubscriptionsExpiry() {
    const { accountSubscriptions } = useAccountSubscriptions();
    const { entitlements } = useSelectUserContext();
    const subscriptionsUsageArray = Object.values(accountSubscriptions);
    const filteredSubscriptions = subscriptionsUsageArray.filter(el => entitlements.includes(el.name));
    return filteredSubscriptions;
}
